import Body from '@oberoninternal/travelbase-ds/components/primitive/Body';
import Title from '@oberoninternal/travelbase-ds/components/primitive/Title';
import { Box, Flex } from '@rebass/grid';
import addDays from 'date-fns/addDays';
import React, { FC } from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';
import { Booking } from '../entities/Booking';
import { PlannerTripFragment, TripTypeEnum } from '../generated/graphql';
import Heading from './designsystem/Heading';
import SpecialTrip from './SpecialTrip';
import Stack from './Stack';

interface Props {
    trips?: PlannerTripFragment[];
    booking: Booking;
    setBooking: (booking: Booking) => void;
}

const AvailableSpecials: FC<React.PropsWithChildren<Props>> = ({ trips = [], booking, setBooking }) => {
    const filteredTrips: PlannerTripFragment[] = trips.filter(trip => {
        if (trip.type === TripTypeEnum.Regular) {
            return false;
        }
        if (booking.trip?.specialId && trip.specialId !== booking.trip.specialId) {
            return false;
        }
        return true;
    });

    if (!filteredTrips?.length) {
        return null;
    }

    const [firstTrip] = filteredTrips;

    const onAddSpecialTrip = (trip: PlannerTripFragment) => {
        setBooking({ trip });
    };

    const onRemoveSpecialTrip = () => {
        // we want the best trip to be selected again.
        setBooking({ trip: trips[0] });
    };

    return (
        <Stack spacing={4} mt={5} className="gt-s">
            <Flex flexDirection={['column', null, null, 'row']}>
                <Box style={{ flexShrink: 0 }} width={[1, null, null, '24rem', '32.8rem']} pr={3}>
                    <Heading mt={5}>
                        <Title>
                            <FormattedMessage defaultMessage="Korting" />
                        </Title>
                        <Body style={{ marginTop: '8px' }}>
                            <FormattedDate value={firstTrip.date} day="numeric" month="short" />
                            {' — '}
                            <FormattedDate
                                value={addDays(new Date(firstTrip.date), firstTrip.duration)}
                                day="numeric"
                                month="short"
                            />
                        </Body>
                    </Heading>
                </Box>
                <Stack spacing={4} flex={1}>
                    {filteredTrips.map((trip, i) => (
                        <SpecialTrip
                            trip={trip}
                            key={i}
                            booking={booking}
                            onAddSpecialTrip={onAddSpecialTrip}
                            onRemoveSpecialTrip={onRemoveSpecialTrip}
                        />
                    ))}
                </Stack>
            </Flex>
        </Stack>
    );
};

export default AvailableSpecials;
